import { faMusic } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, LinearProgress, useTheme } from "@mui/material";
import { useMediaQueryBreakpoint } from "../../../../../hooks/useMediaQuery";
import {
  Button,
  ButtonVariant,
} from "../../../../core-ui/components/Button/Button";
import { Text } from "../../../../core-ui/components/Text/Text";
import { SoundWaveLoader } from "../../../../elements/SoundWaveLoader/SoundWaveLoader";
import {
  UploadReleaseTrackLoadingContainer,
  UploadReleaseTrackSongTitle,
} from "../UploadReleaseTrack.styles";

interface UploadReleaseTrackLoadingProps {
  handleCancelUpload: () => void;
  progressState: number;
  songTitle: string;
  isFileValidating?: boolean;
}

export const UploadReleaseTrackLoading = ({
  handleCancelUpload,
  progressState,
  songTitle,
  isFileValidating = false,
}: UploadReleaseTrackLoadingProps) => {
  const theme = useTheme();
  const { isMobile } = useMediaQueryBreakpoint();
  return (
    <UploadReleaseTrackLoadingContainer>
      {!isFileValidating ? (
        <>
          <Box display="flex" alignItems="center" gap={{ xs: 1, sm: 2 }}>
            <Box display="flex" alignItems="center" gap={1}>
              {!isMobile && (
                <FontAwesomeIcon
                  icon={faMusic}
                  color={theme.palette.text.primary}
                />
              )}
              <Box minWidth="fit-content">
                <UploadReleaseTrackSongTitle bold>
                  {songTitle}
                </UploadReleaseTrackSongTitle>
              </Box>
            </Box>
            <Box width="100%">
              <LinearProgress variant="determinate" value={progressState} />
            </Box>
            <Text sx={{ minWidth: { xs: "36px", sm: "110px" } }}>
              {progressState.toFixed(0)}%{!isMobile && " uploaded"}
            </Text>
          </Box>
          <Button
            variant={ButtonVariant.BLACK_OUTLINED_BUTTON_BLACK_HOVER}
            onClick={handleCancelUpload}
            sx={{ margin: "0 auto" }}
          >
            Cancel Upload
          </Button>
        </>
      ) : (
        <Box alignContent="center" gap={{ xs: 1, sm: 2 }}>
          <SoundWaveLoader width={100} height={100} />
          <Text align="center">File validating...</Text>
        </Box>
      )}
    </UploadReleaseTrackLoadingContainer>
  );
};
